import moment from "moment";
import {
  GET_BOOKS_CATEGORIES,
  SET_PAGE,
  SET_SEARCH,
  SET_COURSE_TYPE,
  SET_ORDER_BY,
  SET_SORT_BY,
} from "../../shared/constants/ActionTypes";

const initialBookCategory = {
  bookCategory: [],
  bookCategoryCount: 0,
  page: 1,
  search: "",
  sortby: "",
  orderby: "desc",
};

const bookCategoryReducer = (state = initialBookCategory, action) => {
  switch (action.type) {
    case GET_BOOKS_CATEGORIES:
      return {
        ...state,
        bookCategory: action.payload.bookCategoriess.map((category) => {
          return {
            ...category,

            updatedAtFormatted: moment(category.createdAt).format("ll"),
          };
        }),
        bookCategoryCount: action.payload.total,
      };

    case SET_PAGE:
      return {
        ...state,
        page: action.payload,
      };

    case SET_SEARCH:
      return {
        ...state,
        search: action.payload,
      };

    case SET_COURSE_TYPE:
      return {
        ...state,
        courseType: action.payload,
      };

    case SET_ORDER_BY:
      return {
        ...state,
        orderby: action.payload,
      };
    case SET_SORT_BY:
      return {
        ...state,
        sortby: action.payload,
      };

    default:
      return state;
  }
};

export default bookCategoryReducer;
